/**
 * @ngdoc enum
 * @name DisplayMode
 *
 * @description
 * Represents a set of predefined application display modes.
 */
export const enum DisplayMode {
	/**
	 * @ngdoc property
	 * @name DisplayMode#BigScreen
	 */
	BigScreen = 1,

	/**
	 * @ngdoc property
	 * @name DisplayMode#Normal
	 */
	Normal = 0,
}
